"use strict";
/**
 * @packageDocumentation @module Chat
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChat = void 0;
var effector_react_1 = require("effector-react");
var chat_1 = require("@yeobill/chat");
/**
 * To get meta info about the running chat as the react hook.
 */
function useChat() {
    return __assign({}, effector_react_1.useStore(chat_1.Chat.Chat));
}
exports.useChat = useChat;
//# sourceMappingURL=useChat.js.map